<p class="text-muted">
    The data generated is based on the invoices reviewed for the selected duration.
</p>
<div class="statistic-total my-3">
    <div class="row">
        <div class="col-lg-3 col-md-6 col-sm-12">
            <div class="total-card total-items ">
                <div class="card-subtitle">
                    <p class="mb-0 w-100">Total no. of Items</p>
                </div>
                <app-table-loader *ngIf="isProductLoading"></app-table-loader>
                <div *ngIf="!isProductLoading"
                    class="growth-rate d-flex align-items-end justify-content-between">
                    <div class="h3 mb-0 text-black">
                        {{ sharedService.formatNumber(productCount?.products) }}
                    </div>
                    <!-- <span class="d-flex align-items-center percentage-value">
                        <i class="material-symbols-outlined material-icons-round pmd-icon-xs me-1">
                            {{ productCount?.change >= 0 ? 'arrow_upward' : 'arrow_downward' }}
                        </i>
                        <span class="pf-cursor-pointer"
                            container="body"
                            pmdTooltip="Your total supplier has {{ productCount?.change >= 0 ? 'increased' : 'decreased' }} by {{ sharedService.formatNumber(productCount?.change >= 0 ? productCount?.change : productCount?.change * -1) }}% compared to the previous period."
                            placement="bottom">
                            {{ sharedService.formatNumber(productCount?.change) }}%
                        </span>
                    </span> -->
                </div>
            </div>
        </div>
        <div class="col-lg-3 col-md-6 col-sm-12 mb-3 mb-lg-0">
            <div class="total-card total-amount mb-xs-0">
                <div class="card-subtitle">
                    <p class="mb-0">Total Payable Amount</p>
                </div>
                <app-table-loader *ngIf="isInvoiceAmountLoading"></app-table-loader>
                <div *ngIf="!isInvoiceAmountLoading"
                    class="growth-rate d-flex align-items-end justify-content-between">
                    <div class="h3 mb-0 text-black">
                        {{ sharedService.formatNumber(invoiceAmount?.amount, true) }}
                    </div>
                    <!-- <span class="d-flex align-items-center percentage-value">
                        <i class="material-symbols-outlined material-icons-round pmd-icon-xs me-1">
                            {{ invoiceAmount?.change >= 0 ? 'arrow_upward' : 'arrow_downward' }}
                        </i>
                        <span class="pf-cursor-pointer"
                            container="body"
                            pmdTooltip="Your total payable amount of invoices has {{ invoiceAmount?.change >= 0 ? 'increased' : 'decreased' }} by {{ sharedService.formatNumber(invoiceAmount?.change >= 0 ? invoiceAmount?.change : invoiceAmount?.change * -1) }}% compared to the previous period."
                            placement="bottom">
                            {{ sharedService.formatNumber(invoiceAmount?.change) }}%
                        </span>
                    </span> -->
                </div>
            </div>
        </div>

        <div class="col-lg-3 col-md-6 col-sm-12">
            <div class="total-card total-amount mb-xs-0">
                <div class="card-subtitle">
                    <p class="mb-0">Total Expense Amount</p>
                </div>
                <app-table-loader *ngIf="isTotalExpenseLoading"></app-table-loader>
                <div *ngIf="!isTotalExpenseLoading"
                    class="growth-rate d-flex align-items-end justify-content-between">
                    <div class="h3 mb-0 text-black">
                        {{ sharedService.formatNumber(totalExpenseAmount.totalExpenseAmount,true) }}
                    </div>
                    <!-- <span class="d-flex align-items-center percentage-value">
                        <i class="material-symbols-outlined material-icons-round pmd-icon-xs me-1">
                            {{ totalExpenseAmount?.change >= 0 ? 'arrow_upward' : 'arrow_downward' }}
                        </i>
                        <span class="pf-cursor-pointer"
                            container="body"
                            pmdTooltip="Total expense amount of invoices has {{ totalExpenseAmount?.change >= 0 ? 'increased' : 'decreased' }} by {{ sharedService.formatNumber(totalExpenseAmount?.change >= 0 ? totalExpenseAmount?.change : totalExpenseAmount?.change * -1) }}% compared to the previous period."
                            placement="bottom">
                            {{ sharedService.formatNumber(totalExpenseAmount?.change) }}%
                        </span>
                    </span> -->
                </div>
            </div>
        </div>
    </div>
</div>
<pmd-card class="px-3 pt-3 box-shadow-none item-tab">
    <div class="card-title h5 d-flex align-items-center">

        <span class="text-black">Item-wise Rate Points</span>
        <i class="material-icons md-dark pmd-icon-xs pmd-accordion-arrow ms-1 pf-cursor-pointer opacity-75"
            container="body"
            pmdTooltip="This report will provide the data at item level for the reviewed invoices."
            placement="bottom">info</i>

        <!-- * Download invoice summary report -->
        <div class="loader-wrap"
            *ngIf="downloadReport">
            <app-table-loader class="h-50"></app-table-loader>
        </div>

        <button type="button"
            *ngIf="!downloadReport"
            pmd-btn
            pmdripple
            color="secondary"
            pmd-btn-outline
            class="pmd-btn-icon px-2 py-1 ms-2"
            size="sm"
            (click)="downloadSupplierItemWiseReport()">
            <svg width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                pmdTooltip="Download"
                xmlns="http://www.w3.org/2000/svg">
                <mask id="mask0_218_123"
                    style="mask-type:alpha"
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="24"
                    height="24">
                    <rect width="24"
                        height="24"
                        fill="#D9D9D9" />
                </mask>
                <g mask="url(#mask0_218_123)">
                    <path
                        d="M6 20C5.45 20 4.97917 19.8042 4.5875 19.4125C4.19583 19.0208 4 18.55 4 18V15H6V18H18V15H20V18C20 18.55 19.8042 19.0208 19.4125 19.4125C19.0208 19.8042 18.55 20 18 20H6Z"
                        fill="#000" />
                    <path d="M17 11L12 16L7 11L8.4 9.55L11 12.15V4H13V12.15L15.6 9.55L17 11Z"
                        fill="#000" />
                </g>
            </svg>
        </button>
    </div>
    <p class="mt-3 mb-0">
        Pick multiple items and suppliers to compare rates.
    </p>
    <!-- (search)="onSearchProductPriceTrend($event)" -->
    <div class="row">
        <div class="col-md-6">
            <div class="mt-2 mb-md-4 khr-entity-dd navbar-multi-select w-100">
                <pmd-input-group-outline>
                    <pmd-input-group-text class="d-none d-sm-flex"
                        for="trendProductNames">Items</pmd-input-group-text>
                    <ng-select [multiple]="true"
                        [clearable]="false"
                        [items]="trendProductNames"
                        maxSelectedItems="5"
                        id="trendProductNames"
                        [(ngModel)]="selectedTrendProductNames"
                        (change)="getProductPriceTrend()"
                        class="pmd-select pmd-select-outline">
                        <ng-template ng-option-tmp
                            let-productName="item">
                            <div class="pmd-checkbox-option">
                                {{ sharedService.capitalize(productName) }}
                            </div>
                        </ng-template>
                        <ng-template ng-multi-label-tmp
                            let-productNames="items"
                            let-clear="clear">
                            <ng-container>
                                <div class="ng-value"
                                    *ngFor="let productName of productNames">
                                    <span class="ng-value-icon right"
                                        (click)="clear(productName)"
                                        aria-hidden="true">×</span>
                                    <span class="ng-value-label invoiceSource"
                                        container="body"
                                        pmdTooltip='{{ sharedService.capitalize(productName) }}'>
                                        {{ sharedService.capitalize(productName) }}
                                    </span>
                                </div>
                            </ng-container>
                        </ng-template>
                    </ng-select>
                </pmd-input-group-outline>
            </div>
        </div>
        <div class="col-md-6">
            <div class="mt-2 mb-md-4 khr-entity-dd navbar-multi-select w-100">
                <pmd-input-group-outline>
                    <pmd-input-group-text class="d-none d-sm-flex"
                        for="supplierNames">Suppliers</pmd-input-group-text>
                    <ng-select [multiple]="true"
                        [clearable]="false"
                        maxSelectedItems="5"
                        [items]="supplierNames"
                        id="supplierNames"
                        maxSelectedItems="5"
                        [(ngModel)]="selectedSupplierNames"
                        (change)="getProductPriceTrend()"
                        class="pmd-select pmd-select-outline">
                        <ng-template ng-option-tmp
                            let-supplierName="item">
                            <div class="pmd-checkbox-option">
                                {{ sharedService.capitalize(supplierName) }}
                            </div>
                        </ng-template>
                        <ng-template ng-multi-label-tmp
                            let-supplierNames="items"
                            let-clear="clear">
                            <ng-container>
                                <div class="ng-value"
                                    *ngFor="let supplierName of supplierNames">
                                    <span class="ng-value-icon right"
                                        (click)="clear(supplierName)"
                                        aria-hidden="true">×</span>
                                    <span class="ng-value-label invoiceSource"
                                        container="body"
                                        pmdTooltip='{{ sharedService.capitalize(supplierName) }}'>
                                        {{ sharedService.capitalize(supplierName) }}
                                    </span>
                                </div>
                            </ng-container>
                        </ng-template>
                    </ng-select>
                </pmd-input-group-outline>
            </div>
        </div>
    </div>
    <div class="loader-wrap"
        *ngIf="isProductPriceTrendLoading">
        <app-table-loader class="h-100"></app-table-loader>
    </div>
    <app-line-chart *ngIf="!isProductPriceTrendLoading && lineSeries?.length"
        class="line-chart"
        [series]="lineSeries">
    </app-line-chart>
    <app-empty-chart *ngIf="!isProductPriceTrendLoading && !lineSeries?.length"></app-empty-chart>
</pmd-card>
<pmd-card class="box-shadow-none px-3 py-3 item-tab">

    <div class="card-title h5 d-flex flex-wrap align-items-center justify-content-between">
        <span class="text-black">Item-wise Rate Overview</span>
        <div class="col-12 col-md-6 col-xl-3 d-flex gap-2 align-items-center mt-3 mt-md-0">
            <i class="material-icons md-dark pmd-icon-xs pmd-accordion-arrow ms-1 pf-cursor-pointer opacity-75"
                container="body"
                pmdTooltip="Shows item-wise min/max/latest rate along with respective quantity and suppliers."
                placement="bottom">info</i>
            <pmd-input-group-outline
                class="khr-input-group-outline-icon input-group-sm khr-icon-r flex-1 border-r-full">
                <pmd-textfield-outline pmd-floating-label>
                    <form [formGroup]="itemWiseOverviewFilterForm">
                        <div class="duration-dropdown d-flex align-items-center"
                            pmdDropdown
                            [positionFixed]="true"
                            (onShown)="onDurationPickerOpen()"
                            [autoClose]="true"
                            pmdPlacement="bottom-end">
                            <pmd-input-group-outline pmd-input-group-icon>
                                <pmd-textfield pmd-textfield-outline>
                                    <input pmdTextField
                                        pmdDropdownToggle
                                        placeholder="Select Duration"
                                        id="datePicker"
                                        class="form-control form-control-sm dropdown-toggle p-auto"
                                        formControlName="duration"
                                        aria-label="datepicker"
                                        aria-describedby="datepicker"
                                        readonly />
                                    <i (click)="getDuration('clear');setDuration()"
                                        *ngIf="g.duration.value"
                                        class="material-icons md-dark pmd-icon-xs pmd-accordion-arrow cursor-pointer icon_right">
                                        close
                                    </i>
                                </pmd-textfield>
                            </pmd-input-group-outline>
                            <div class="dropdown-menu date-mobile-product"
                                *pmdDropdownMenu>
                                <div>
                                    <div class="customrange-datepicker">
                                        <pmd-daterangepicker-inline (bsValueChange)="durationChange($event)"
                                            [bsConfig]="{ showWeekNumbers: false, todayHighlight: true}"
                                            [bsValue]="itemWiseOverviewDuration"
                                            [maxDate]="today">
                                            <div class="pmd-datepicker-predefined-btns pmd-datepicker-custom-range">
                                                <h6 class="dropdown-header">Date selection</h6>
                                                <a class="dropdown-item"
                                                    href="javascript:void(0);"
                                                    (mouseenter)="getDuration('thisWeek')"
                                                    (mouseleave)="getDuration('reset')"
                                                    (click)="setDuration()">This Week</a>
                                                <a class="dropdown-item"
                                                    href="javascript:void(0);"
                                                    (mouseenter)="getDuration('lastWeek')"
                                                    (mouseleave)="getDuration('reset')"
                                                    (click)="setDuration()">Last Week</a>
                                                <a class="dropdown-item"
                                                    href="javascript:void(0);"
                                                    (mouseenter)="getDuration('fortnight')"
                                                    (mouseleave)="getDuration('reset')"
                                                    (click)="setDuration()">Last 15 Days</a>
                                                <a class="dropdown-item"
                                                    href="javascript:void(0);"
                                                    (mouseenter)="getDuration('MTD')"
                                                    (mouseleave)="getDuration('reset')"
                                                    (click)="setDuration()">Month Till Date</a>
                                                <a class="dropdown-item"
                                                    href="javascript:void(0);"
                                                    (mouseenter)="getDuration('YTD')"
                                                    (mouseleave)="getDuration('reset')"
                                                    (click)="setDuration()">Year Till Date</a>
                                                <a class="dropdown-item active"
                                                    (mouseenter)="getDuration('today')"
                                                    (mouseleave)="getDuration('clear')"
                                                    href="javascript:void(0);">Custom Range</a>
                                            </div>
                                        </pmd-daterangepicker-inline>
                                        <div class="pmd-datepicker-buttons">
                                            <span class="ml-auto me-4"
                                                *ngIf="itemWiseOverviewDuration && itemWiseOverviewDuration.length">
                                                <span class="ml-auto me-2 fromDateLable">
                                                    {{ itemWiseOverviewDuration[0].toLocaleDateString("en-US",
                                                    appGlobals.dateFormat) }}
                                                </span>
                                                <span class="ml-auto me-2"> to </span>
                                                <span class="ml-auto me-2 toDateLable">
                                                    {{ itemWiseOverviewDuration[1].toLocaleDateString("en-US",
                                                    appGlobals.dateFormat) }}
                                                </span>
                                            </span>
                                            <button pmd-btn
                                                (click)="getDuration('clear');setDuration()"
                                                pmdRipple
                                                color="light"
                                                class="me-2 btn-light-gray">
                                                Cancel
                                            </button>
                                            <button pmd-btn-raised
                                                (click)="setDuration()"
                                                pmdRipple
                                                color="secondary">
                                                Apply
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </pmd-textfield-outline>
                <pmd-input-group-text class="pmd-input-icon-absolute border-0 bg-white">
                    <i class="material-icons pmd-icon-xs "
                        color="secondary">calendar_month</i>
                </pmd-input-group-text>
            </pmd-input-group-outline>
        </div>
    </div>

    <p class="mt-3 mb-0">
        Pick multiple items and know the Minimum / Maximum and Latest purchase rates.
    </p>
    <div class="khr-entity-dd navbar-multi-select w-100 mt-3">
        <pmd-input-group-outline>
            <pmd-input-group-text class="d-none d-sm-flex"
                for="productNames">Items</pmd-input-group-text>
            <ng-select [multiple]="true"
                [clearable]="false"
                [items]="productNames"
                id="productNames"
                [(ngModel)]="selectedProductNames"
                (search)="onSearchProductWiseAnalysis($event)"
                (change)="getProductPriceDetail()"
                class="pmd-select pmd-select-outline">
                <ng-template ng-option-tmp
                    let-productName="item">
                    <div class="pmd-checkbox-option">
                        {{ sharedService.capitalize(productName) }}
                    </div>
                </ng-template>
                <ng-template ng-multi-label-tmp
                    let-productNames="items"
                    let-clear="clear">
                    <ng-container>
                        <div class="ng-value"
                            *ngFor="let productName of productNames">
                            <span class="ng-value-icon right"
                                (click)="clear(productName)"
                                aria-hidden="true">×</span>
                            <span class="ng-value-label invoiceSource"
                                container="body"
                                pmdTooltip='{{ sharedService.capitalize(productName) }}'>
                                {{ sharedService.capitalize(productName) }}
                            </span>
                        </div>
                    </ng-container>
                </ng-template>
            </ng-select>
        </pmd-input-group-outline>
    </div>
    <div class="invalid-feedback"
        style="display: block;">
        {{ maxProductSelectionError }}
    </div>
    <!-- Table List -->
    <div class="table-responsive table-responsive-md p-0 box-shadow-none mt-3">
        <table cellspacing="0"
            cellpadding="0"
            class="table pmd-table"
            role="grid"
            aria-label="Course listing">
            <thead class="thead-light">
                <tr class="thead-bg">
                    <th tabindex="-1"
                        class="pe-0"
                        style="min-width: unset;"
                        rowspan="2">
                    </th>
                    <th tabindex="-1"
                        aria-label="Customer Name column"
                        id="customerName"
                        rowspan="2"
                        class="coursename-column column-sorting">
                        <div class="d-flex align-items-center">Item</div>
                    </th>
                    <th tabindex="-1"
                        aria-label="No. of Invoices column"
                        id="invoiceNo"
                        class="column-sorting"
                        rowspan="2">Average Rate (₹)</th>
                    <th tabindex="-1"
                        aria-label="Minumum"
                        id="invoiceNo"
                        class="column-sorting text-center bg-success-light"
                        colspan="3">Minimum</th>
                    <th tabindex="-1"
                        aria-label="Minumum"
                        id="invoiceNo"
                        class="column-sorting text-center bg-danger-light"
                        colspan="3">Maximum</th>
                    <th tabindex="-1"
                        aria-label="Minumum"
                        id="invoiceNo"
                        class="column-sorting text-center bg-info-light"
                        colspan="2">Latest</th>
                    <th tabindex="-1"
                        aria-label="Invoices Amount (₹) column"
                        id="issueDate"
                        class="column-sorting"
                        rowspan="2">
                        % Gap
                    </th>
                </tr>
                <tr class="thead-bg">
                    <th tabindex="-1"
                        aria-label="Invoices Amount (₹) column"
                        id="issueDate"
                        class="column-sorting bg-success-light">
                        Supplier
                    </th>
                    <th tabindex="-1"
                        aria-label="GST Amount column"
                        id="dueDate"
                        class="column-sorting w-30 bg-success-light">
                        Qty
                    </th>
                    <th tabindex="-1"
                        aria-label="Taxable Amount column"
                        id="dueDate"
                        class="column-sorting bg-success-light">
                        Rate (₹)
                    </th>
                    <th tabindex="-1"
                        aria-label="Invoices Amount (₹) column"
                        id="issueDate"
                        class="column-sorting bg-danger-light">
                        Supplier
                    </th>
                    <th tabindex="-1"
                        aria-label="GST Amount column"
                        id="dueDate"
                        class="column-sorting w-30 bg-danger-light">
                        Qty
                    </th>
                    <th tabindex="-1"
                        aria-label="Taxable Amount column"
                        id="dueDate"
                        class="column-sorting bg-danger-light">
                        Rate (₹)
                    </th>
                    <th tabindex="-1"
                        aria-label="Invoices Amount (₹) column"
                        id="issueDate"
                        class="column-sorting bg-info-light">
                        Supplier
                    </th>
                    <th tabindex="-1"
                        aria-label="Invoices Amount (₹) column"
                        id="dueDate"
                        class="column-sorting bg-info-light">
                        Rate (₹)
                    </th>
                </tr>
            </thead>
            <tbody>
                <ng-container *ngFor="let product of products; let i = index">
                    <tr>
                        <td tabindex="-1"
                            class="pe-0 checkbox-column">
                        </td>
                        <td tabindex="-1"
                            class="col-12 col-sm-8 col-md-6 pf-column-name">
                            <div class="d-flex">
                                <div class="flex-grow-1">
                                    <div class="card-title mb-1 invoiceSource"
                                        container="body"
                                        pmdTooltip='{{ sharedService.capitalize(product.description) }}'>
                                        {{ sharedService.capitalize(product.description) }}
                                    </div>
                                </div>
                            </div>
                        </td>
                        <td data-title="Invoice No."
                            tabindex="-1"
                            class="col-6 col-sm-4 col-md-3 invoice-number"
                            aria-describedby="courseSimulator">
                            <p class="card-title mb-1 text-nowrap">
                                {{ sharedService.formatNumber(product.averageRate, true, 0, 2, true) +
                                (product.minUnit ? ' /' + sharedService.capitalize(product.minUnit) : '') }}
                            </p>
                        </td>
                        <td data-title="Seller Name"
                            class="col-6 col-sm-4 col-md-3 bg-success-light">
                            <p class="card-title mb-1 supplierName pf-cursor-pointer"
                                container="body"
                                pmdTooltip='{{ sharedService.capitalize(product.minSupplier) }}'
                                placement="bottom">
                                {{ sharedService.capitalize(product.minSupplier) }}
                            </p>
                        </td>
                        <td data-title="Amount"
                            class="col col-md text-sm-start bg-success-light">
                            <p class="card-title mb-1 text-nowrap">
                                {{ sharedService.formatNumber(product.minQuantity, false, 0, 2, true) +
                                ' ' + sharedService.capitalize(product.minUnit) }}
                            </p>
                        </td>
                        <td data-title="Amount"
                            class="col col-md text-sm-start bg-success-light">
                            <p class="card-title mb-1 text-nowrap">
                                {{ sharedService.formatNumber(product.minRate, true, 0, 2, true) +
                                (product.minUnit ? ' /' + sharedService.capitalize(product.minUnit) : '') }}
                            </p>
                        </td>
                        <td data-title="Seller Name"
                            class="col-6 col-sm-4 col-md-3 bg-danger-light">
                            <p class="card-title mb-1 supplierName pf-cursor-pointer"
                                container="body"
                                pmdTooltip='{{ sharedService.capitalize(product.maxSupplier) }}'
                                placement="bottom">
                                {{ sharedService.capitalize(product.maxSupplier) }}
                            </p>
                        </td>
                        <td data-title="Amount"
                            class="col col-md text-sm-start bg-danger-light">
                            <p class="card-title mb-1 text-nowrap">
                                {{ sharedService.formatNumber(product.maxQuantity, false, 0, 2, true) +
                                ' ' + sharedService.capitalize(product.maxUnit) }}
                            </p>
                        </td>
                        <td data-title="Amount"
                            class="col col-md text-sm-start bg-danger-light">
                            <p class="card-title mb-1 text-nowrap">
                                {{ sharedService.formatNumber(product.maxRate, true, 0, 2, true) +
                                (product.minUnit ? ' /' + sharedService.capitalize(product.minUnit) : '') }}
                            </p>
                        </td>
                        <td data-title="Seller Name"
                            class="col-6 col-sm-4 col-md-3 bg-info-light">
                            <p class="card-title mb-1 supplierName pf-cursor-pointer"
                                container="body"
                                pmdTooltip='{{ sharedService.capitalize(product.latestSupplier) }}'
                                placement="bottom">
                                {{ sharedService.capitalize(product.latestSupplier) }}
                            </p>
                        </td>
                        <td data-title="Amount"
                            class="col col-md text-sm-start bg-info-light">
                            <p class="card-title mb-1 text-nowrap">
                                {{ sharedService.formatNumber(product.latestRate, true, 0, 2, true) +
                                (product.minUnit ? ' /' + sharedService.capitalize(product.minUnit) : '') }}
                            </p>
                        </td>
                        <td data-title="Invoice Date"
                            class="col-6 col-sm-4 col-md-3 issue-due-date">
                            <app-semi-donut-chart [series]="[product.gap]"></app-semi-donut-chart>
                        </td>
                    </tr>
                </ng-container>
            </tbody>
        </table>
    </div>
    <!-- End Table List -->
</pmd-card>
<pmd-card class="px-3 pt-3 box-shadow-none item-tab">
    <h4 class="h5 cart-title d-flex align-items-center">
        <span class="text-black">
            Item-wise Amount contribution
        </span>
        <i class="material-icons md-dark pmd-icon-xs pmd-accordion-arrow ms-1 pf-cursor-pointer opacity-75"
            container="body"
            pmdTooltip="Shows Item wise % contribution to the Total Taxable Amount"
            placement="bottom">info</i>
    </h4>
    <div class="loader-wrap"
        *ngIf="isProductWiseSummaryLoading">
        <app-table-loader class="h-100"></app-table-loader>
    </div>
    <app-treemap-chart *ngIf="!isProductWiseSummaryLoading && treemapSeries?.length"
        [series]="treemapSeries"
        [customTooltip]="treemapCustomTooltip">
    </app-treemap-chart>
    <app-empty-chart *ngIf="!isProductWiseSummaryLoading && !treemapSeries?.length"></app-empty-chart>
</pmd-card>
<pmd-card class="px-3 pt-3 box-shadow-none item-tab">
    <h4 class="h5 cart-title d-flex align-items-center mb-4">
        <span class="text-black">
            Item-wise Taxable Amount
        </span>
        <i class="material-icons md-dark pmd-icon-xs pmd-accordion-arrow ms-1 pf-cursor-pointer opacity-75"
            container="body"
            pmdTooltip="Shows Item wise Taxable Amount"
            placement="bottom">info</i>
    </h4>
    <div class="loader-wrap"
        *ngIf="isProductWiseSummaryLoading">
        <app-table-loader class="h-100"></app-table-loader>
    </div>
    <app-mixed-chart *ngIf="!isProductWiseSummaryLoading && mixedCategories?.length"
        [series]="mixedSeries"
        [categories]="mixedCategories"
        [yAxisRange]="mixedYAxisRange"
        [isProduct]="true">
    </app-mixed-chart>
    <app-empty-chart *ngIf="!isProductWiseSummaryLoading && !mixedCategories?.length"></app-empty-chart>
</pmd-card>